export default [
  { name: 'Name', prop: 'name', type: 'text' },
  {
    name: 'Type',
    prop: 'type',
    type: 'select',
    options: [
      {
        name: 'Webinar',
        value: 'webinar'
      },
      {
        name: 'Product',
        value: 'product'
      }
    ]
  }
]
